/**
 * @file スライダー
 *
 */
'use strict';

/**
 * @classname SliderView
 * @classdesc スライダー
 */
export default class SliderView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('SliderView.constructor');
		this._$e = $e;
		if($e.hasClass('slider-top')) {
			this.topSlider();
		}else if($e.hasClass('slider-main')){
			this.mainSlider();
		}else if($e.hasClass('slider-nav')){
			this.navSlider();
		}
	};


	/**
	 * トップスライダー
	 *
	 * @memberof SliderView
	 * @return {undefined}
	 */
	topSlider() {
		console.log('SliderView.mainSlider');
		if($(window).width() <= 768){
			this._$e.slick({
				dots: true,
				infinite: true,
				autoplaySpeed: 3000,
				cssEase: 'linear',
				arrows: false,
				autoplay: true
			});
		}
	}


	/**
	 * メインスライダー
	 *
	 * @memberof SliderView
	 * @return {undefined}
	 */
	mainSlider() {
		console.log('SliderView.mainSlider');
		this._$e.slick({
			slideToShow: 1,
			slideToScroll: 1,
			arrows: false,
			asNavFor: '.slider-nav',
			autoplay: true,
			infinite: true
		});
	}


	/**
	 * ナビスライダー
	 *
	 * @memberof SliderView
	 * @return {undefined}
	 */
	navSlider() {
		console.log('SliderView.navSlider');
		if(this._$e.hasClass('slider-nav-2')){
			this._$e.slick({
				asNavFor: '.slider-main',
				dots: true,
				centerMode: true,
				centerPadding: 0,
				slidesToShow: 2,
				slidesToScroll: 1,
				focusOnSelect: true,
				infinite: true
			});
		}else{
			this._$e.slick({
				asNavFor: '.slider-main',
				dots: true,
				centerMode: true,
				centerPadding: 0,
				slidesToShow: 3,
				slidesToScroll: 1,
				focusOnSelect: true,
				infinite: true
			});
		}
	}
}
